// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import mainSlider from './js/widgets/mainSlider.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import * as socialNetworkWidget from './js/widgets/socialWidget.js';
import sponsors from './js/widgets/sponsors.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets

$(document).ready(function () {
  headerButton();
});

if (window.location.pathname === '/') {
  $(document).ready(function () {
    mainSlider();
    seoWidget();
    cardWidget();
    sponsors();

    $(globalThis).on('load', function () {
      videoWidget();
      socialNetworkWidget.facebookfeed(true);
    });
  });
}
